import { render, staticRenderFns } from "./BasicInformationAboutSubjectSelect.vue?vue&type=template&id=ec609fc8&"
import script from "./BasicInformationAboutSubjectSelect.vue?vue&type=script&lang=js&"
export * from "./BasicInformationAboutSubjectSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports